import { render } from "./Main.vue?vue&type=template&id=ceb3949a"
const script = {}
script.render = render

export default script